// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ProjectTask  {
    _originalTypeClassName = "Loom.BO.ProjectTask";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ProjectTask.translate = translateService;
}
this.SubTasks = [];
this.Assignments = [];
this.Id = null;
this.Number = null;
this.Name = null;
this.StartMonth = null;
this.StartDate = null;
this.EndMonth = null;
this.EndDate = null;
this.DurationInMonths = null;
this.NumberedName = null;
this.DescriptionOfWork = null;
this.TotalPersonMonthsBudgeted = null;
this.Objectives = null;
this.AllRelatedSkillsAsString = null;
this.TaskPercentage = null;
this.DueDate = null;
this.Level = null;
this.ClickUpListId = null;
this.ClickUpTaskId = null;
this.ClickUpUrl = null;
this.Caption = null;
this.NumberInt = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Number:any;
Name:any;
StartMonth:any;
StartDate:any;
EndMonth:any;
EndDate:any;
DurationInMonths:any;
NumberedName:any;
DescriptionOfWork:any;
TotalPersonMonthsBudgeted:any;
Objectives:any;
AllRelatedSkillsAsString:any;
TaskPercentage:any;
DueDate:any;
Level:any;
ClickUpListId:any;
ClickUpTaskId:any;
ClickUpUrl:any;
Caption:any;
NumberInt:any;
ParentTask:any;
SubTasks:any;
WorkPackage:any;
Assignments:any;
static setParentTask = ($this, value) => {
var oldValue = $this.ParentTask;
$this.ParentTask = value;
if (value != null) {
if (oldValue != null) {
Domain.ProjectTask.removeSubTasks(oldValue, $this);
}
Domain.ProjectTask.addSubTasks(value, $this);
}
}
static setSubTasks = ($this, items) => {
                if (items == null) items = [];
                if ($this.SubTasks == null) $this.SubTasks = [];

                const copyItems = Common.cloneObject(items);

                while ($this.SubTasks.length > 0) {
                    Domain.ProjectTask.removeSubTasks($this, $this.SubTasks[0]);
                }

                Domain.ProjectTask.addManySubTasks($this, copyItems);
            }
static addManySubTasks = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.ProjectTask.addSubTasks($this, items[i]);
                }
            }
static addSubTasks = ($this, item) => {
                if ($this.SubTasks == null) $this.SubTasks = [];
                if (item == null || $this.SubTasks.indexOf(item) > -1) return;
                $this.SubTasks.push(item);
if (item.ParentTask != $this) {
Domain.ProjectTask.setParentTask(item, $this);
}
}
static addRangeSubTasks = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.ProjectTask.addSubTasks($this, item));
            }
static removeSubTasks = ($this, item) => {
                if ($this == null || $this.SubTasks == null || $this.SubTasks.indexOf(item) === -1) return;
                var _index = $this.SubTasks.indexOf(item);
                $this.SubTasks.splice(_index, 1);
item.ParentTask = null;
}
static clearSubTasks = ($this) => { $this.SubTasks = null; }
static setWorkPackage = ($this, value) => {
var oldValue = $this.WorkPackage;
$this.WorkPackage = value;
if (value != null) {
if (oldValue != null) {
Domain.WorkPackage.removeTasks(oldValue, $this);
}
Domain.WorkPackage.addTasks(value, $this);
}
}
static setAssignments = ($this, items) => {
                if (items == null) items = [];
                if ($this.Assignments == null) $this.Assignments = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Assignments.length > 0) {
                    Domain.ProjectTask.removeAssignments($this, $this.Assignments[0]);
                }

                Domain.ProjectTask.addManyAssignments($this, copyItems);
            }
static addManyAssignments = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.ProjectTask.addAssignments($this, items[i]);
                }
            }
static addAssignments = ($this, item) => {
                if ($this.Assignments == null) $this.Assignments = [];
                if (item == null || $this.Assignments.indexOf(item) > -1) return;
                $this.Assignments.push(item);
if (item.Task != $this) {
Domain.ParticipantWorkAssignment.setTask(item, $this);
}
}
static addRangeAssignments = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.ProjectTask.addAssignments($this, item));
            }
static removeAssignments = ($this, item) => {
                if ($this == null || $this.Assignments == null || $this.Assignments.indexOf(item) === -1) return;
                var _index = $this.Assignments.indexOf(item);
                $this.Assignments.splice(_index, 1);
item.Task = null;
}
static clearAssignments = ($this) => { $this.Assignments = null; }

static GetCaption($this: any): any{return $this?.Number + " - " + $this?.Name;
}
static GetDueDate($this: any): any{let Time = Joove.Common.dateDiff(new Date(new Date($this?.EndDate)?.setHours(0, 0, 0, 0)), new Date(new Date(moment().toDate())?.setHours(0, 0, 0, 0)))?.days;
let result = "";
if (CLMS.Framework.Number.GreaterThan(() => Time, () => 30) && CLMS.Framework.Number.LessThan(() => Time, () => 365)) {Time = Joove.Common.safeNumber(Time) / Joove.Common.safeNumber(30);return Time?.toString() + " month(s) remaining";}else if (CLMS.Framework.Number.GreaterThanOrEqual(() => Time, () => 365)) {Time = Joove.Common.safeNumber(Time) / Joove.Common.safeNumber(365);return Time?.toString() + " year(s) remaining";}else if (CLMS.Framework.Number.GreaterThan(() => Time, () => 0)) {return Time?.toString() + " day(s) remaining";}else {return "Finished!";}
}
static GetDurationInMonths($this: any): any{return Joove.Common.safeNumber($this?.EndMonth) - Joove.Common.safeNumber($this?.StartMonth) + Joove.Common.safeNumber(1);
}
static GetEffortByParticipants($this: any, participantIds: any): any{if (participantIds == null || CLMS.Framework.Number.LessThanOrEqual(() => participantIds.length, () => 0)) {return $this?.TotalPersonMonthsBudgeted;}
return $this?.Assignments?.linq?.where((a) => participantIds?.linq?.contains(a?.Participant?.Id))?.toArray()?.linq?.sum((a) => a?.Effort);
}
static GetEndDate($this: any): any{let proj = ($this?.WorkPackage != null ? $this?.WorkPackage?.Project : $this?.ParentTask?.WorkPackage?.Project);
return Domain.Project.GetMonthDates(proj, $this?.EndMonth)[1];
}
static GetLevel($this: any): any{let myWP = $this?.WorkPackage;
if ((myWP != null)) {return 1;}
if (($this?.ParentTask == null)) {return 2;}
return Joove.Common.safeNumber(Domain.ProjectTask.GetLevel($this?.ParentTask)) + Joove.Common.safeNumber(1);
}
static GetNumberInt($this: any): any{try {let numText = $this?.Number;if ((numText?.indexOf("T") === 0)) {numText = Joove.Common.replaceAll(numText, "T", "");if ((Joove.Common.stringContains(numText, "."))) {numText = System.split(numText, '.')[1];}}else if ((numText?.indexOf("ST") === 0)) {numText = Joove.Common.replaceAll(numText, "ST", "");if ((Joove.Common.stringContains(numText, "."))) {let parts = System.split(numText, '.');numText = parts[Joove.Common.safeNumber(parts?.length) - Joove.Common.safeNumber(1)];}}if ((Joove.Common.stringContains(numText, "."))) {let parts = System.split(numText, '.');numText = parts[Joove.Common.safeNumber(parts?.length) - Joove.Common.safeNumber(1)];}let num = CLMS.Framework.Integer.Parse(numText);return num;}
catch (x) {console.warn("Error parsing Task number: " + $this?.Number);return 0;}
}
static GetParentProject(projectTask: any): any{if (projectTask == null) {return null;}
if (projectTask?.WorkPackage != null && !(Domain.WorkPackage.IsNew(projectTask?.WorkPackage))) {return projectTask?.WorkPackage?.Project;}
return Domain.ProjectTask.GetParentProject(projectTask?.ParentTask);
}
static GetStartDate($this: any): any{let proj = ($this?.WorkPackage != null ? $this?.WorkPackage?.Project : $this?.ParentTask?.WorkPackage?.Project);
return Domain.Project.GetMonthDates(proj, $this?.StartMonth)[0];
}
static GetTaskPercentage($this: any): any{if ((CLMS.Framework.Number.LessThanOrEqual(() => $this.EndMonth, () => 0) || CLMS.Framework.Number.LessThanOrEqual(() => Domain.ProjectTask.GetDurationInMonths($this), () => 0))) {return 0;}
let wpCurrMonth = Joove.Common.safeNumber($this?.WorkPackage?.Project?.CurrentMonth) - Joove.Common.safeNumber($this?.StartMonth) + Joove.Common.safeNumber(1);
if ((CLMS.Framework.Number.LessThan(() => wpCurrMonth, () => 0))) {return 0;}
return Joove.Common.safeNumber((parseFloat((wpCurrMonth) as any))) / Joove.Common.safeNumber((parseFloat((Domain.ProjectTask.GetDurationInMonths($this)) as any)));
}
static IsActiveInProjectMonth($this: any, month: any): any{return CLMS.Framework.Number.LessThanOrEqual(() => $this.StartMonth, () => month) && CLMS.Framework.Number.GreaterThanOrEqual(() => $this.EndMonth, () => month);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}